import React, { useState, useEffect } from "react";
import { Table, Modal, Spinner, Alert } from "react-bootstrap";
import { useAlert } from "react-alert";
import { baseUrl } from "../../../../services/config";
import Paper from "@material-ui/core/Paper";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { PremissionChecker } from "../../../../services/PremissionChecker";
import { useSelector } from "react-redux";
const DefineCourses = () => {
  const user = useSelector((state) => state.user.user);
  const authtoken = localStorage.getItem("userToken");

  const [courseTypes, setCourseTypes] = useState([]);

  const [courseModal, setCourseModal] = useState(false);
  const [courseName, setCourseName] = useState("");
  const [courseSlug, setCourseSlug] = useState("");
  const [courseTypeId, setCourseTypeId] = useState("");
  const [courseDurationId, setCourseDurationId] = useState("");

  const [editCourseModal, setEditCourseModal] = useState(false);
  const [editCoursesId, setEditCoursesId] = useState([]);
  const [editCourseName, setEditCourseName] = useState("");
  const [editCourseSlug, setEditCourseSlug] = useState("");
  const [editCourseTypeIdData, setEditCourseTypeIdData] = useState("");
  const [editCourseDurationIdData, setEditCourseDurationIdData] = useState("");

  const [deleteCourseModal, setdeleteCourseModal] = useState(false);
  const [deleteableCourse, setDeleteableCourse] = useState([]);

  const [loading, setloading] = useState(false);
  const [isallfields, setisallfields] = useState(false);
  const [addCourseLoading, setAddCourseLoading] = useState(false);
  const alert = useAlert();

  const [courseTypeData, setCourseTypeData] = useState([]);
  const [courseTypeModal, setCourseTypeModal] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [courseTypeName, setCourseTypeName] = useState("");

  const [editCourseTypeModal, setEditCourseTypeModal] = useState(false);
  const [editCourseTpyeId, setEditCourseTpyeId] = useState([]);
  const [editCourseTypeName, setEditCourseTypeName] = useState("");

  const [deleteCourseTypeModal, setdeleteCourseTypeModal] = useState(false);
  const [deleteableCourseType, setDeleteableCourseType] = useState([]);
  const [deleteloading, setdeleteloading] = useState(false);

  const [courseDurationData, setCourseDurationData] = useState([]);
  const [courseDurationModal, setCourseDurationModal] = useState(false);
  const [courseDurationName, setCourseDurationName] = useState("");
  const [courseDuration, setCourseDuration] = useState("");

  const [editCourseDurationModal, setEditCourseDurationModal] = useState(false);
  const [editCourseDurationId, setEditCourseDurationId] = useState([]);
  const [editCourseDurationName, setEditCourseDurationName] = useState("");
  const [editCourseDuration, setEditCourseDuration] = useState("");

  const [deleteCourseDurationModal, setdeleteCourseDurationModal] = useState(
    false
  );
  const [deleteableCourseDuration, setDeleteableCourseDuration] = useState([]);

  useEffect(() => {
    getCourses();
    getCourseType();
    getCourseDuration();
  }, []);

  const getCourses = async () => {
    setloading(true);
    await fetch(`${baseUrl}/course`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCourseTypes(data.payload);
          setloading(false);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const getCourseType = async () => {
    await fetch(`${baseUrl}/course-type`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCourseTypeData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const getCourseDuration = async () => {
    await fetch(`${baseUrl}/course-duration`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCourseDurationData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const addCourseHandler = async () => {
    if (
      courseName == "" ||
      courseSlug == "" ||
      courseTypeId == "" ||
      courseDurationId == ""
    ) {
      setisallfields(true);
      return;
    }
    setisallfields(false);
    const data = {
      name: courseName,
      slug: courseSlug,
      course_type_id: courseTypeId,
      course_duration_id: courseDurationId,
    };

    await fetch(`${baseUrl}/course`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            setCourseModal(false);
            alert.success("Course successfully Added");
            getCourses();
            setCourseName("");
            setCourseSlug("");
            setCourseTypeId("");
            setCourseDurationId("");
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setCourseModal(false);
          } else {
            alert.show("Something Went Wrong");
            setCourseModal(false);
          }
        })
      )
      .catch((err) => {
        setAddCourseLoading(false);
        setCourseModal(false);
        console.log(err);
      });
  };

  const getEditCourse = async (id) => {
    await fetch(`${baseUrl}/course/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setEditCourseName(data.payload?.name);
          setEditCourseSlug(data.payload?.slug);
          setEditCourseTypeIdData(data.payload?.course_type_id);
          setEditCourseDurationIdData(data.payload?.course_duration_id);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const updateCourseHandler = async () => {
    if (
      editCourseName == "" ||
      editCourseSlug == "" ||
      editCourseTypeIdData == "" ||
      editCourseDurationIdData == ""
    ) {
      setisallfields(true);
      return;
    }
    setisallfields(false);
    const data = {
      name: editCourseName,
      slug: editCourseSlug,
      course_type_id: editCourseTypeIdData,
      course_duration_id: editCourseDurationIdData,
    };

    await fetch(`${baseUrl}/course/${editCoursesId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            setEditCourseModal(false);
            alert.success("Course successfully Updated");
            getCourses();
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setEditCourseModal(false);
          } else {
            alert.show("Something Went Wrong");
            setEditCourseModal(false);
          }
        })
      )
      .catch((err) => {
        setAddCourseLoading(false);
        setCourseModal(false);
        console.log(err);
      });
  };

  const deleteCourseHandle = async () => {
    setdeleteloading(true);

    await fetch(`${baseUrl}/course/${deleteableCourse.id}}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success(data.payload);
            getCourses();
            setdeleteloading(false);
            setdeleteCourseModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setdeleteloading(false);
            setdeleteCourseModal(false);
          }
        } else {
          alert.show("Something Went Wrong");
          setdeleteloading(false);
          setdeleteCourseModal(false);
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("err", err);
        setdeleteloading(false);
        setdeleteCourseModal(false);
      });
  };

  // Course Type Function
  const courseTypeHandler = async () => {
    if (courseTypeName == "") {
      return alert.error("Course Type Name Is Required");
    }

    setSubmitLoading(true);
    const data = {
      name: courseTypeName,
    };
    setSubmitLoading(false);
    await fetch(`${baseUrl}/course-type`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          setSubmitLoading(false);
          if (data.metadata.success) {
            alert.success("Course Type Successfully Added");
            setCourseTypeName("");
            getCourseType();
            setCourseTypeModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setCourseTypeModal(false);
          }
        } else {
          alert.show("Something Went Wrong");
          setCourseTypeModal(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setSubmitLoading(false);
      });
  };

  const getEditCourseType = async (id) => {
    await fetch(`${baseUrl}/course-type/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setEditCourseTypeName(data.payload?.name);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const updateCourseTypeHandler = async () => {
    if (editCourseTypeName == "") {
      return alert.error("Course Type Name Is Required");
    }

    setSubmitLoading(true);
    const data = {
      name: editCourseTypeName,
    };
    setSubmitLoading(false);
    await fetch(`${baseUrl}/course-type/${editCourseTpyeId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          setSubmitLoading(false);
          if (data.metadata.success) {
            alert.success("Course Type Successfully Updated");
            getCourseType();
            setEditCourseTypeModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setEditCourseTypeModal(false);
          }
        } else {
          alert.show("Something Went Wrong");
          setEditCourseTypeModal(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setSubmitLoading(false);
      });
  };

  const deleteCourseTypeHandle = async () => {
    setdeleteloading(true);

    await fetch(`${baseUrl}/course-type/${deleteableCourseType.id}}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success(data.payload);
            getCourseType();
            setdeleteloading(false);
            setdeleteCourseTypeModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setdeleteloading(false);
            setdeleteCourseTypeModal(false);
          }
        } else {
          alert.show("Something Went Wrong");
          setdeleteloading(false);
          setdeleteCourseTypeModal(false);
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("err", err);
        setdeleteloading(false);
        setdeleteCourseTypeModal(false);
      });
  };

  // Course Duration Function
  const courseDurationHandler = async () => {
    if (courseDurationName == "") {
      return alert.error("Course Type Name Is Required");
    }
    if (courseDuration == "") {
      return alert.error("Duration Is Required");
    }

    setSubmitLoading(true);
    const data = {
      name: courseDurationName,
      duration: courseDuration,
    };
    setSubmitLoading(false);
    await fetch(`${baseUrl}/course-duration`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          setSubmitLoading(false);
          if (data.metadata.success) {
            alert.success("Course Duration Successfully Added");
            setCourseDurationName("");
            setCourseDuration("");
            getCourseDuration();
            setCourseDurationModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setCourseDurationName("");
            setCourseDuration("");
            getCourseDuration();
            setCourseDurationModal(false);
          }
        } else {
          alert.show("Something Went Wrong");
          setCourseDurationModal(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setSubmitLoading(false);
      });
  };

  const getEditCourseDuration = async (id) => {
    await fetch(`${baseUrl}/course-duration/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setEditCourseDurationName(data.payload?.name);
          setEditCourseDuration(data.payload?.duration);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const updateCourseDurationHandler = async () => {
    if (editCourseDurationName == "") {
      return alert.error("Course Duration Name Is Required");
    }
    if (editCourseDuration == "") {
      return alert.error("Duration Is Required");
    }

    setSubmitLoading(true);
    const data = {
      name: editCourseDurationName,
      duration: editCourseDuration,
    };
    setSubmitLoading(false);
    await fetch(`${baseUrl}/course-duration/${editCourseDurationId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          setSubmitLoading(false);
          if (data.metadata.success) {
            alert.success("Course Duration Successfully Updated");
            getCourseDuration();
            setEditCourseDurationModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setEditCourseDurationModal(false);
          }
        } else {
          alert.show("Something Went Wrong");
          setEditCourseDurationModal(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setSubmitLoading(false);
      });
  };

  const deleteCourseDurationHandle = async () => {
    setdeleteloading(true);

    await fetch(`${baseUrl}/course-type/${deleteableCourseDuration.id}}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success(data.payload);
            getCourseDuration();
            setdeleteloading(false);
            setdeleteCourseDurationModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setdeleteloading(false);
            setdeleteCourseDurationModal(false);
          }
        } else {
          alert.show("Something Went Wrong");
          setdeleteloading(false);
          setdeleteCourseDurationModal(false);
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("err", err);
        setdeleteloading(false);
        setdeleteCourseTypeModal(false);
      });
  };

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div>
          <button
            disabled={!PremissionChecker(user, "campus.can_add_course")}
            onClick={() => setCourseModal(true)}
            className="btn btn-primary mr-2"
          >
            Add New Course
          </button>

          <button
            disabled={!PremissionChecker(user, "campus.can_add_course_type")}
            className="btn btn-primary mr-2"
            onClick={() => setCourseTypeModal(true)}
          >
            Add Course Type
          </button>

          <button
            disabled={
              !PremissionChecker(user, "campus.can_add_course_duration")
            }
            className="btn btn-primary"
            onClick={() => setCourseDurationModal(true)}
          >
            Add Course Duration
          </button>
        </div>
        {/* ) : (
          ""
        )} */}
        <div>
          <Table responsive>
            <thead>
              <tr>
                <th className="text-center">ID</th>
                <th className="text-center">Course Name</th>
                <th className="text-center">Course Slug</th>
                <th className="text-center">Course Type</th>
                <th className="text-center">Course Duration</th>
                <th className="text-center">Edit</th>
                <th className="text-center">Delete</th>
              </tr>
            </thead>
            <tbody>
              {courseTypes.map((courseType, index) => (
                <tr key={index}>
                  <td className="text-center">{courseType?.id}</td>
                  <td className="text-center">{courseType?.name}</td>
                  <td className="text-center">{courseType?.slug}</td>
                  <td className="text-center">{courseType?.course_type}</td>
                  <td className="text-center">
                    {courseType?.course_duration_name}
                  </td>

                  <td className="text-center">
                    <a
                      className={
                        "btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                      }
                      onClick={() => {
                        getEditCourse(courseType?.id);
                        setEditCoursesId(courseType?.id);
                        setEditCourseModal(true);
                      }}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-primary ">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Write.svg"
                          )}
                        />
                      </span>
                    </a>
                  </td>
                  <td className="text-center">
                    <a
                      className={
                        "btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                      }
                      onClick={() => {
                        setDeleteableCourse(courseType);
                        setdeleteCourseModal(true);
                      }}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-danger">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Delete-user.svg"
                          )}
                        />
                      </span>
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <div className="row justify-content-center">
            {loading && (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            )}
          </div>
        </div>

        {/* ------------------------Courses Start----------------------- */}
        {/* Add Course */}
        <Modal show={courseModal} size="lg">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Add New Course
            </Modal.Title>
          </Modal.Header>

          {addCourseLoading ? (
            <div style={{ padding: "25px" }}>
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          ) : (
            <Modal.Body>
              <div className="row">
                <div className="col-md-6">
                  <label htmlFor="course_name">
                    Course Name<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    name="course_name"
                    className="form-control"
                    placeholder="Enter Course Name"
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setisallfields(true);
                      } else {
                        setisallfields(false);
                      }
                      setCourseName(e.target.value);
                    }}
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="course_name">
                    Course Slug<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    name="course_slug"
                    className="form-control"
                    placeholder="Enter Course Name"
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setisallfields(true);
                      } else {
                        setisallfields(false);
                      }
                      setCourseSlug(e.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="row mt-5">
                <div className="col-md-6">
                  <label htmlFor="course_type_id">
                    Select Course Type<span style={{ color: "red" }}>*</span>
                  </label>

                  <select
                    className="form-select form-control"
                    name="course_type_id"
                    value={courseTypeData.id}
                    onChange={(e) => {
                      if (e.value == 0) {
                        setisallfields(true);
                      } else {
                        setisallfields(false);
                      }
                      setCourseTypeId(e.target.value);
                    }}
                    style={{ backgroundColor: "white" }}
                    aria-label="Default select example"
                  >
                    <option value="">Select Course Type</option>
                    {courseTypeData.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6">
                  <label htmlFor="course_type_id">
                    Select Course Duration
                    <span style={{ color: "red" }}>*</span>
                  </label>

                  <select
                    className="form-select form-control"
                    name="course_type_id"
                    value={courseDurationId}
                    onChange={(e) => {
                      if (e.value == 0) {
                        setisallfields(true);
                      } else {
                        setisallfields(false);
                      }
                      setCourseDurationId(e.target.value);
                    }}
                    style={{ backgroundColor: "white" }}
                    aria-label="Default select example"
                  >
                    <option value="">Select Course Type</option>
                    {courseDurationData.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <br />
              <br />
              {isallfields ? (
                <>
                  <Alert
                    variant="danger"
                    onClose={() => setisallfields(false)}
                    dismissible
                  >
                    <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                    <p>Please fill or select all fields</p>
                  </Alert>
                </>
              ) : null}
            </Modal.Body>
          )}

          <Modal.Footer>
            {addCourseLoading ? (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              <button
                className="btn btn-success button_blue"
                onClick={addCourseHandler}
              >
                Add Course
              </button>
            )}
            <button
              className="btn btn-danger btn_width"
              onClick={() => {
                setCourseModal(false);
                setisallfields(false);
                setCourseName("");
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* Update Course */}
        <Modal show={editCourseModal} size="lg">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Update Course
            </Modal.Title>
          </Modal.Header>

          {addCourseLoading ? (
            <div style={{ padding: "25px" }}>
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          ) : (
            <Modal.Body>
              <div className="row">
                <div className="col-md-6">
                  <label htmlFor="course_name">
                    Course Name<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    name="course_name"
                    className="form-control"
                    placeholder="Enter Course Name"
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setisallfields(true);
                      } else {
                        setisallfields(false);
                      }
                      setEditCourseName(e.target.value);
                    }}
                    value={editCourseName}
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="course_name">
                    Course Slug<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    name="course_slug"
                    className="form-control"
                    placeholder="Enter Course Name"
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setisallfields(true);
                      } else {
                        setisallfields(false);
                      }
                      setEditCourseSlug(e.target.value);
                    }}
                    value={editCourseSlug}
                  />
                </div>
              </div>

              <div className="row mt-5">
                <div className="col-md-6">
                  <label htmlFor="course_type_id">
                    Select Course Type<span style={{ color: "red" }}>*</span>
                  </label>

                  <select
                    className="form-select form-control"
                    name="course_type_id"
                    value={editCourseTypeIdData}
                    onChange={(e) => {
                      if (e.value == 0) {
                        setisallfields(true);
                      } else {
                        setisallfields(false);
                      }
                      setEditCourseTypeIdData(e.target.value);
                    }}
                    style={{ backgroundColor: "white" }}
                    aria-label="Default select example"
                  >
                    <option value="">Select Course Type</option>
                    {courseTypeData.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6">
                  <label htmlFor="course_type_id">
                    Select Course Duration
                    <span style={{ color: "red" }}>*</span>
                  </label>

                  <select
                    className="form-select form-control"
                    name="course_type_id"
                    value={editCourseDurationIdData}
                    onChange={(e) => {
                      if (e.value == 0) {
                        setisallfields(true);
                      } else {
                        setisallfields(false);
                      }
                      setEditCourseDurationIdData(e.target.value);
                    }}
                    style={{ backgroundColor: "white" }}
                    aria-label="Default select example"
                  >
                    <option value="">Select Course Type</option>
                    {courseDurationData.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <br />
              <br />
              {isallfields ? (
                <>
                  <Alert
                    variant="danger"
                    onClose={() => setisallfields(false)}
                    dismissible
                  >
                    <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                    <p>Please fill or select all fields</p>
                  </Alert>
                </>
              ) : null}
            </Modal.Body>
          )}

          <Modal.Footer>
            {addCourseLoading ? (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              <button className="btn btn-primary" onClick={updateCourseHandler}>
                Update Course
              </button>
            )}
            <button
              className="btn btn-danger btn_width"
              onClick={() => {
                setEditCourseModal(false);
                setisallfields(false);
                setCourseName("");
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* Delete Course */}
        <Modal show={deleteCourseModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Are you sure want to delete this course?
            </Modal.Title>
          </Modal.Header>
          {deleteloading ? (
            <div style={{ padding: "20px" }}>
              {" "}
              <b style={{ color: "green" }}>
                {" "}
                Fee Deleting Please Wait{" "}
                <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Footer>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button
                  onClick={deleteCourseHandle}
                  className="btn button_blue"
                >
                  Delete
                </button>
                <button
                  style={{ marginLeft: "10px" }}
                  onClick={() => setdeleteCourseModal(false)}
                  className="btn btn-danger btn_width"
                >
                  Cancel
                </button>
              </div>
            </Modal.Footer>
          )}
        </Modal>
        {/* ------------------------Course End----------------------- */}

        {/* ------------------------Course Type Start----------------------- */}
        {/* Add Course Type  */}
        <Modal show={courseTypeModal} size="md">
          <Modal.Header>
            <Modal.Title>Add New Course Type</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <label className="form-control-label">
                <b>
                  Enter Course Type Name <span style={{ color: "red" }}>*</span>{" "}
                </b>
              </label>
              <input
                className="form-control"
                value={courseTypeName}
                onChange={(e) => setCourseTypeName(e.target.value)}
                placeholder="Enter Course Type Name"
              />
            </div>

            <Table responsive>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Type Name</th>
                  <th className="text-center">Edit</th>
                  <th className="text-center">Delete</th>
                </tr>
              </thead>
              <tbody>
                {courseTypeData.map((courseData, index) => (
                  <tr key={index}>
                    <td style={{ textAlign: "center" }}>{courseData?.id}</td>
                    <td style={{ textAlign: "start" }}>{courseData?.name}</td>
                    <td className="text-center">
                      <a
                        className={
                          "btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                        }
                        onClick={() => {
                          setEditCourseTpyeId(courseData?.id);
                          getEditCourseType(courseData?.id);
                          setEditCourseTypeModal(true);
                        }}
                      >
                        <span className="svg-icon svg-icon-md svg-icon-primary ">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Communication/Write.svg"
                            )}
                          />
                        </span>
                      </a>
                    </td>
                    <td className="text-center">
                      <a
                        className={
                          "btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                        }
                        onClick={() => {
                          setDeleteableCourseType(courseData);
                          setdeleteCourseTypeModal(true);
                        }}
                      >
                        <span className="svg-icon svg-icon-md svg-icon-danger">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Communication/Delete-user.svg"
                            )}
                          />
                        </span>
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            {submitLoading ? (
              <div
                style={{
                  width: "80px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Spinner
                  className="text-center"
                  variant="info"
                  animation="border"
                />
              </div>
            ) : (
              <button onClick={courseTypeHandler} className="btn btn-primary">
                Add Course Type
              </button>
            )}

            <button
              onClick={() => setCourseTypeModal(false)}
              className="btn btn-danger"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* Update Course Type */}
        <Modal show={editCourseTypeModal} size="md">
          <Modal.Header>
            <Modal.Title>Update Course Type</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <label className="form-control-label">
                <b>
                  Enter Course Type Name <span style={{ color: "red" }}>*</span>{" "}
                </b>
              </label>
              <input
                className="form-control"
                value={editCourseTypeName}
                onChange={(e) => setEditCourseTypeName(e.target.value)}
                placeholder="Enter Course Type Name"
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            {submitLoading ? (
              <div
                style={{
                  width: "80px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Spinner
                  className="text-center"
                  variant="info"
                  animation="border"
                />
              </div>
            ) : (
              <button
                onClick={updateCourseTypeHandler}
                className="btn btn-primary"
              >
                Update
              </button>
            )}

            <button
              onClick={() => setEditCourseTypeModal(false)}
              className="btn btn-danger"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* Delete Course Type */}
        <Modal show={deleteCourseTypeModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Are you sure want to delete this course type?
            </Modal.Title>
          </Modal.Header>
          {deleteloading ? (
            <div style={{ padding: "20px" }}>
              {" "}
              <b style={{ color: "green" }}>
                {" "}
                Fee Deleting Please Wait{" "}
                <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Footer>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button
                  onClick={deleteCourseTypeHandle}
                  className="btn button_blue"
                >
                  Delete
                </button>
                <button
                  style={{ marginLeft: "10px" }}
                  onClick={() => setdeleteCourseTypeModal(false)}
                  className="btn btn-danger btn_width"
                >
                  Cancel
                </button>
              </div>
            </Modal.Footer>
          )}
        </Modal>
        {/* ------------------------Course Type End----------------------- */}

        {/* ------------------------Course Duration Start----------------------- */}
        {/* Add Course Duration  */}
        <Modal show={courseDurationModal} size="md">
          <Modal.Header>
            <Modal.Title>Add New Course Duration</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <label className="form-control-label">
                <b>
                  Enter Duration Nmae <span style={{ color: "red" }}>*</span>{" "}
                </b>
              </label>
              <input
                className="form-control text-uppercase"
                value={courseDurationName}
                onChange={(e) => setCourseDurationName(e.target.value)}
                placeholder="Enter Duration Name"
              />
            </div>

            <div className="mt-5">
              <label className="form-control-label">
                <b>
                  Enter Duration <span style={{ color: "red" }}>*</span>{" "}
                </b>
              </label>
              <input
                className="form-control"
                value={courseDuration}
                onChange={(e) => setCourseDuration(e.target.value)}
                placeholder="Enter Duration"
              />
            </div>

            <Table responsive>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Duration Name</th>
                  <th>Duration</th>
                  <th className="text-center">Edit</th>
                  <th className="text-center">Delete</th>
                </tr>
              </thead>
              <tbody>
                {courseDurationData.map((courseDurationData, index) => (
                  <tr key={index}>
                    <td style={{ textAlign: "center" }}>
                      {courseDurationData?.id}
                    </td>
                    <td style={{ textAlign: "start" }}>
                      {courseDurationData?.name}
                    </td>
                    <td style={{ textAlign: "start" }}>
                      {courseDurationData?.duration}
                    </td>
                    <td className="text-center">
                      <a
                        className={
                          "btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                        }
                        onClick={() => {
                          setEditCourseDurationId(courseDurationData?.id);
                          getEditCourseDuration(courseDurationData?.id);
                          setEditCourseDurationModal(true);
                        }}
                      >
                        <span className="svg-icon svg-icon-md svg-icon-primary ">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Communication/Write.svg"
                            )}
                          />
                        </span>
                      </a>
                    </td>
                    <td className="text-center">
                      <a
                        className={
                          "btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                        }
                        onClick={() => {
                          setDeleteableCourseDuration(courseDurationData);
                          setdeleteCourseModal(true);
                        }}
                      >
                        <span className="svg-icon svg-icon-md svg-icon-danger">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Communication/Delete-user.svg"
                            )}
                          />
                        </span>
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            {submitLoading ? (
              <div
                style={{
                  width: "80px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Spinner
                  className="text-center"
                  variant="info"
                  animation="border"
                />
              </div>
            ) : (
              <button
                onClick={courseDurationHandler}
                className="btn btn-primary"
              >
                Add Course Duration
              </button>
            )}

            <button
              onClick={() => setCourseDurationModal(false)}
              className="btn btn-danger"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* Update Course Duration */}
        <Modal show={editCourseDurationModal} size="md">
          <Modal.Header>
            <Modal.Title>Update Course Duration</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <label className="form-control-label">
                <b>
                  Enter Course Duration Name{" "}
                  <span style={{ color: "red" }}>*</span>{" "}
                </b>
              </label>
              <input
                className="form-control text-uppercase"
                value={editCourseDurationName}
                onChange={(e) => setEditCourseDurationName(e.target.value)}
                placeholder="Enter Course Duration Name"
              />
            </div>
            <div className="mt-5">
              <label className="form-control-label">
                <b>
                  Enter Duration <span style={{ color: "red" }}>*</span>{" "}
                </b>
              </label>
              <input
                className="form-control"
                value={editCourseDuration}
                onChange={(e) => setEditCourseDuration(e.target.value)}
                placeholder="Enter Duration"
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            {submitLoading ? (
              <div
                style={{
                  width: "80px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Spinner
                  className="text-center"
                  variant="info"
                  animation="border"
                />
              </div>
            ) : (
              <button
                onClick={updateCourseDurationHandler}
                className="btn btn-primary"
              >
                Update
              </button>
            )}

            <button
              onClick={() => setEditCourseDurationModal(false)}
              className="btn btn-danger"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* Delete Course Duration */}
        <Modal show={deleteCourseDurationModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Are you sure want to delete this course duration?
            </Modal.Title>
          </Modal.Header>
          {deleteloading ? (
            <div style={{ padding: "20px" }}>
              {" "}
              <b style={{ color: "green" }}>
                {" "}
                Fee Deleting Please Wait{" "}
                <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Footer>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button
                  onClick={deleteCourseDurationHandle}
                  className="btn button_blue"
                >
                  Delete
                </button>
                <button
                  style={{ marginLeft: "10px" }}
                  onClick={() => setdeleteCourseTypeModal(false)}
                  className="btn btn-danger btn_width"
                >
                  Cancel
                </button>
              </div>
            </Modal.Footer>
          )}
        </Modal>
        {/* ------------------------Course Duration End----------------------- */}
      </Paper>
    </div>
  );
};

export default DefineCourses;
